<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <div class="header_container" navTabs>
        <sbnb-page-header>
          <h2 class="no-decoration">Update your password</h2>
        </sbnb-page-header>
        <div style="font-size: 14px; color: #b3afbb; font-family: 'Cera'">
          Updating your password will invalidate all other logged in sessions.
        </div>
      </div>
      <h2 fxLayout fxLayoutAlign="space-apart center">
        <div fxFlex fxLayout="column" fxLayoutGap="6px">
          <span>Update your password</span>
          <span style="font-size: 14px; color: #b3afbb; font-family: 'Cera'">
            Updating your password will invalidate all other logged in sessions.
          </span>
        </div>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </h2>
    </app-feature-flag-tabs>

    <form [formGroup]="securityForm">
      <div class="grid sm:grid-cols-[170px,1fr] sm:gap-y-2">
        <strong class="profile__label">Current password</strong>
        <mat-form-field class="input__mini mt-2 sm:mt-0 sm:[&_.mat-form-field-flex]:w-[300px]">
          <input matInput type="password" formControlName="currentPassword" />
          <mat-error *ngIf="securityForm.get('currentPassword').hasError('required')">
            Current password is required
          </mat-error>
          <mat-error *ngIf="securityForm.get('currentPassword').hasError('minlength')">
            Current password should be at least 8 characters
          </mat-error>
          <mat-error
            class="truncate"
            *ngIf="securityForm.get('currentPassword').hasError('apiValidationError')"
            [title]="securityForm.get('currentPassword').getError('apiValidationError')">
            {{ securityForm.get('currentPassword').getError('apiValidationError') }}
          </mat-error>
        </mat-form-field>

        <strong class="profile__label">New password</strong>
        <mat-form-field class="input__mini mt-2 sm:mt-0 sm:[&_.mat-form-field-flex]:w-[300px]">
          <input matInput type="password" formControlName="newPassword1" />
          <mat-error *ngIf="securityForm.get('newPassword1').hasError('required')">New password is required</mat-error>
          <mat-error *ngIf="securityForm.get('newPassword1').hasError('minlength')">
            New password should be at least 8 characters
          </mat-error>
          <mat-error
            class="truncate"
            *ngIf="securityForm.get('newPassword1').hasError('apiValidationError')"
            [title]="securityForm.get('newPassword1').getError('apiValidationError')">
            {{ securityForm.get('newPassword1').getError('apiValidationError') }}
          </mat-error>
        </mat-form-field>

        <strong class="profile__label">Repeat new password</strong>
        <mat-form-field class="input__mini mt-2 sm:mt-0 sm:[&_.mat-form-field-flex]:w-[300px]">
          <input matInput type="password" formControlName="newPassword2" />
          <mat-error *ngIf="securityForm.get('newPassword2').hasError('required')">
            Repeat password is required
          </mat-error>
          <mat-error *ngIf="securityForm.get('newPassword2').hasError('minlength')">
            Repeat password should be at least 8 characters
          </mat-error>
          <mat-error
            *ngIf="
              securityForm.get('newPassword1').value !== securityForm.get('newPassword2').value &&
              securityForm.get('newPassword2').value
            ">
            New passwords are not matching
          </mat-error>
          <mat-error
            class="truncate"
            *ngIf="securityForm.get('newPassword2').hasError('apiValidationError')"
            [title]="securityForm.get('newPassword2').getError('apiValidationError')">
            {{ securityForm.get('newPassword2').getError('apiValidationError') }}
          </mat-error>
        </mat-form-field>
      </div>

      <button
        [disabled]="saving || !securityForm.valid"
        type="submit"
        class="button__small"
        mat-flat-button
        (click)="save()">
        Save changes
        <mat-spinner *ngIf="saving" class="button__spinner" diameter="16"></mat-spinner>
      </button>
    </form>

    <div style="margin-top: 60px">
      <sbnb-authorized-devices-list></sbnb-authorized-devices-list>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
